<template>
    <div>

    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        methods: {

        },
        created() {

        }
    }

</script>
<style>
    /*表格内容居中*/
    .el-table td, .el-table th {
        text-align: center !important;
    }
    /*删除提示位置提高*/
    .el-message-box {
        margin-top: -300px;
    }
</style>
<style scoped>

</style>